// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5bdd73cb","703":"91447917"}[chunkId] + ".chunk.js";
};